import Image from '@/components/UI/Image';
import { useGlobal } from '@/utils/useGlobal';
import { useMemo } from 'react';
import styled from './index.module.scss';
const StoryMenu = () => {
    const { useState, isMobile, useLang, Link } = useGlobal();
    const { t } = useLang('brandstory');
    const navlist = [
        {
            imgurl: '/img/stories/common/menu/menu1.png',
            name: t('menu.newday'),
            link: 'storyNewday',
        },
        {
            imgurl: '/img/stories/common/menu/menu2.png',
            name: t('menu.newlight'),
            link: 'storyNewlight',
        },
        {
            imgurl: '/img/stories/common/menu/menu3.png',
            name: t('menu.newhouse'),
            link: 'storyNewhouse',
        },
        {
            imgurl: '/img/stories/common/menu/menu4.png',
            name: t('menu.newtaste'),
            link: 'storyNewtaste',
        },
        {
            imgurl: '/img/stories/common/menu/menu6.png',
            name: t('menu.newnight'),
            link: 'storyNewnight',
        },
        {
            imgurl: '/img/stories/common/menu/menu5.png',
            name: t('menu.newcommunity'),
            link: 'storyCommunity',
        },
    ];

    /**
     * 数组的数据格式转换拆分-----一维转二维
     * @param {Object} arr 源数组
     * @param {Object} len 二维中一维的长度
     */
    const splitArray = (arr: Array<Record<string, string>>, len: number): Array<Array<Record<string, string>>> => {
        const arrLen = arr.length;
        const result = [];
        for (let i = 0; i < arrLen; i += len) {
            result.push(arr.slice(i, i + len));
        }
        return result;
    };
    const pcList = splitArray(navlist, 3);

    const handleScrollTo = (id: string) => {
        document.getElementById(id)?.scrollIntoView({
            behavior: 'smooth',
        });
    };

    const navHtml = useMemo(() => {
        if (isMobile) {
            return (
                <div className="menu_box">
                    {navlist.map((item, index) => (
                        <div key={index} className="menu_item" onClick={() => handleScrollTo(item.link)}>
                            <Image src={item.imgurl} layout="fill" className="fullImgs" alt={item.name} aria-label={item.name} />
                            <p className="name">{item.name}</p>
                        </div>
                    ))}
                </div>
            );
        }
        return (
            <>
                {pcList.map((value, key) => (
                    <div className="menu_box" key={`box-${key}`}>
                        {value.map((item, index) => (
                            <div key={index} className="menu_item" onClick={() => handleScrollTo(item.link)}>
                                <Image src={item.imgurl} layout="fill" className="fullImgs" alt={item.name} aria-label={item.name} />
                                <p>{item.name}</p>
                            </div>
                        ))}
                    </div>
                ))}
            </>
        );
    }, [isMobile]);

    return (
        <div className={`${isMobile ? styled.story_mobilemenu : styled.story_menu}`}>
            <h5 className="screen-title">{t('menu.title')}</h5>
            <h5 className="screen-desc">{t('menu.desc')}</h5>
            {navHtml}
        </div>
    );
};

export default StoryMenu;
